import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../antd/form/FormValidation';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect';
import FormCheckBox from '../../../../antd/form/FormCheckBox/FormCheckBox';

export function SensorAttributeFields({
  units = [],
  isIconDisabled = false,
  parentName = [],
}) {
  const { t } = useTranslation();

  const unitOptions = useMemo(
    () => (units || []).map((unit) => ({ value: unit.id, label: unit.unit })),
    [units],
  );
  const orderOptions = useMemo(
    () =>
      [...Array(7).keys()].map((key) => ({
        value: key,
        label: key === 0 ? t('Nezobrazovať') : `${key}.`,
      })),
    [t],
  );

  return (
    <>
      <FormTextField
        label={t('Popis atribútu')}
        name={[...parentName, 'label']}
        rules={[required(t)]}
      />

      <FormSelect
        options={unitOptions}
        label={t('Jednotka')}
        name={[...parentName, 'attribute_unit_id']}
        rules={[required(t)]}
      />

      <FormSelect
        options={orderOptions}
        label={t('Poradie v bloku na domovskej stránke')}
        name={[...parentName, 'order']}
        rules={[required(t)]}
      />

      <FormTextField
        label={t('Ikona')}
        name={[...parentName, 'icon']}
        disabled={isIconDisabled}
        placeholder={
          isIconDisabled
            ? t('Pre tento atribút bude použitá špeciálna ikona')
            : t('Vložte príslušnú ikonu')
        }
      />

      <FormCheckBox
        label={t('Povoliť vytváranie grafov')}
        name={[...parentName, 'is_graphable']}
      />
    </>
  );
}
